// ** React Import

// ** Custom Components
import Sidebar from '@components/sidebar';
import ToastError from '@components/toast/ToastError';
import CustomDatePicker from '@components/datepicker';

// ** Utils
// import { selectThemeColors } from '@utils';

import { scheduledMembershipOptions, scheduledNotificationTypeOptions } from '../../../utility/Options';

// ** Third Party Components
import * as yup from 'yup';
import { Formik } from 'formik';

// ** Reactstrap Imports
import { Button, Label, FormFeedback, Form, Input, Row, Col, FormGroup } from 'reactstrap';
import toast from 'react-hot-toast';

// ** Graphql
import {
  CreateScheduledNotification,
  UpdateScheduledNotification
} from '../../../graphql/Mutation/notifications';
import { useMutation } from '@apollo/client';
import { makeUniqueId } from '@apollo/client/utilities';

// ** Schema yup
const Schema = yup.object().shape({
  title: yup.string().required('Ingresa un titulo'),
  membership: yup
    .array()    
    .min(1, "You can't leave this blank.")
    .required('Tienes que seleccionar una opcion valida'),
  active: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('Este campos es requerido'),
  date: yup.string().required('Tienes que seleccionar una hora'),
  days: yup.number().required('Tienes que seleccionar un dia'),
  message: yup.string().required('El mensaje no puede estar vacio'),
  notificationType:yup.string().required('El tipo no puede estar vacio')
});

const FormSidebar = ({ open, toggleSidebar, defaultValues }) => {
  // ** mutations **
  const [handle] = useMutation(
    defaultValues?._id ? UpdateScheduledNotification : CreateScheduledNotification
  );
  // ** States
  const handleSidebarClosed = () => {};
  const onSubmit = async (values) => {
    const data = {
      ...values,
      active: String(values.active) === 'true',
      __typename: undefined,
      _id: undefined,
      days:parseInt(values.days)
    };
    let variables = { input: data };
    if (defaultValues?._id) {
      variables = {
        input: {
          _id: defaultValues._id,
          data
        }
      };
    }
    try {
      await handle({
        variables
      });
      toggleSidebar();
    } catch (e) {
      const errors = e.graphQLErrors;
      errors?.forEach((error) => {
        const message =
          error?.extensions?.exception?.response?.es ||
          error?.extensions?.response?.message[0];
        toast((t) => <ToastError t={t} message={message} />);
      });
    }
  };

  const handleValidateForm = async ({ validateForm, setErrors, values }) => {
    const errors = await validateForm();    
    if (Object.keys(errors).length) {
      
      setErrors(errors);
      return;
    }
    await onSubmit(values);
  };

  return (
    <Sidebar
      size="lg"
      open={open}
      title={'Crear Notificación'}
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={handleSidebarClosed}
    >
      <Formik
        initialValues={defaultValues}
        validateOnChange
        validateOnBlur
        validationSchema={Schema}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          touched,
          setErrors,
          validateForm,
          setFieldValue
        }) => (
          <Form>
             <div className="mb-1">             
                <Label className="form-label" for="days">
                  Tipo de Notificación 
                </Label>
                <Input
                  type="select"
                  name="notificationType"
                  id="notificationType"
                  onChange={(val) => { handleChange(val); setFieldValue('notificationType', val.target.value); } }
                  onBlur={handleBlur}
                  invalid={errors.notificationType && true}
                  value={values.notificationType}
                >                                                
                  {scheduledNotificationTypeOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Input>
                {errors.notificationType && touched.notificationType && (
                  <FormFeedback>Requerido</FormFeedback>
                )}                                         
            </div>
            <div className="mb-1">
              <Label className="form-label" for="title">
                Titulo
              </Label>
              <Input
                type="text"
                name="title"
                id="title"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.title}
                placeholder="Escribenos aqui..."
                invalid={errors.title && true}
              />
              {errors.title && touched.title && (
                <FormFeedback>{errors.title}</FormFeedback>
              )}
            </div>

            <div className="mb-1">
              <Label className="form-label" for="message">
                Tu Mensaje
              </Label>
              <Input
                type="textarea"
                name="message"
                id="message"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.message}
                placeholder=""
                invalid={errors.message && true}
              />
              {errors.message && touched.message && (
                <FormFeedback>{errors.message}</FormFeedback>
              )}
            </div>
            { (values.notificationType === 'MEMBERSHIP' || values.notificationType === 'LASTLOGIN') &&
            <div className="mb-1">
              <Row>
                <Col>
                      <Label className="form-label" for="days">
                        Días 
                      </Label>
                      <Input
                        type="select"
                        name="days"
                        id="days"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={errors.days && true}
                        value={values.days}
                      >                                                
                        {[...Array(366).keys()].map((item) => (
                          <option key={makeUniqueId(Date.now())} value={item}>
                            {item}
                          </option>
                        ))}
                      </Input>
                      {errors.days && touched.days && (
                        <FormFeedback>Requerido</FormFeedback>
                      )}
                </Col>
                {values.notificationType === 'MEMBERSHIP' &&
                    <Col>
                        <Label className="form-label" for="date">
                          Hora de envío
                        </Label>
                        <Input
                            type="time"
                            name="date"
                            id="date"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.date}
                            placeholder=""
                            invalid={errors.date && true}
                          />
                        {errors.date && touched.date && (
                          <FormFeedback>{errors.date}</FormFeedback>
                        )}
                    </Col>
                }
              </Row>                            
            </div>
            }
             {values.notificationType === 'MEMBERSHIP' &&
                  <div className="mb-1">
                    <Label className="form-label" for="membership">
                      Tipo de membresía 
                    </Label><br/>             
                    {scheduledMembershipOptions.map((item) => (
                      <FormGroup
                      check
                      inline                
                      >
                          <Label className="form-label">
                            {item.label}
                          </Label>
                            <Input
                              type="checkbox"
                              name="membership"                        
                              onChange={handleChange}
                              onBlur={handleBlur}                       
                              value={item.value}
                              checked={values.membership.includes(item.value)}

                            />
                      </FormGroup>      
                      ))}                                                       
                    {errors.membership && (
                      <FormFeedback style={{display:'block'}}>Requerido</FormFeedback>
                    )}
                  </div>
            }
            <div className="mb-1">
              <Label className="form-label" for="active">
                Estado
              </Label>
              <Input
                type="select"
                name="active"
                id="active"
                placeholder="Seleccionar Estado"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.active}
                invalid={errors.active && true}
                required
              >
                <option disabled value="initial">
                  Seleccionar Estado
                </option>
                <option value={true}>Activo</option>
                <option value={false}>Inactivo</option>
              </Input>
              {errors.active && touched.active && (
                <FormFeedback>Requerido</FormFeedback>
              )}
            </div>
            <div style={{ height: '20px' }} />
            <Button
              className="me-1 mt-1"
              color="primary"
              onClick={() =>
                handleValidateForm({ validateForm, setErrors, values })
              }
            >
              {defaultValues?._id ? `Actualizar` : `Crear`}
            </Button>
          </Form>
        )}
      </Formik>
    </Sidebar>
  );
};

export default FormSidebar;
